import { useContext, useEffect, useState } from "react";
import { 
    AppSpan, Button, CenterPopupContainer, Form, FormGroup,
    CustomContainer, FixedContainer, FlexRow, ScreenTitle, FormGroupWithIcon 
} from "src/style"
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import { NewCustomerLayout } from 'src/component'
import { useNotifier } from "react-pop-notifier"
import { FiChevronDown } from "react-icons/fi";

export const NewCustomerBasicDetails: React.FC<any> = ({next, close}) => {
    const {notifier} = useNotifier()
    const {info: {customerCreationProcess}, setInfoProperty} = useContext(AppInfoContext)
    const [input, setInput] = useState({
        firstName: '', lastName: '', 
        mobileNo: '', email: '', channel: '',
        platform: ''
    })

    useEffect(() => {
        if (customerCreationProcess) {
            const {firstName, lastName, mobileNo, email, platform, channel} = customerCreationProcess
            setInput({
                ...input, 
                firstName, 
                lastName, 
                mobileNo, 
                email,
                platform,
                channel
            }) 
        }
    }, [customerCreationProcess])

    const handleInput = (e: React.ChangeEvent<HTMLInputElement|HTMLSelectElement>) => setInput({...input, [e.target.name]: e.target.value})

    async function handleNext(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()
    
        await setInfoProperty('customerCreationProcess', {...customerCreationProcess, ...input, basicDetails: true})
        next()
    }

    return (
        <>
            <CenterPopupContainer onClick={close} />
            <FixedContainer
                top="50" tSizeUnit="%" 
                left="50" lSizeUnit="%"
                bgColor="#ffffff" zIndex='9'
                height='82.6' width='123.6'
                radius='0.8'
                className="popup-container-lg"
            >
                <NewCustomerLayout currentScreen='basic-details'>
                    <CustomContainer bottomMargin="2.5">
                        <ScreenTitle 
                            textSize="2" color="#111111" 
                            fontWeight="600"
                        >
                            Set Up basic details for the Customer
                        </ScreenTitle>
                        <AppSpan textSize="1.6" color="#4F4F4F">
                            Orci, porttitor feugiat sociis quis pellentesque non morbi. 
                            Ultricies mi dignissim lorem in. Vitae aliquet gravida sed massa dolor.
                        </AppSpan>
                    </CustomContainer>
                    <Form topMargin='3' onSubmit={handleNext}>
                        <FlexRow 
                            justifyContent='space-between' gap='2'
                            className='user-basic-input-row'
                        >
                            <FormGroup bottomMargin='0'>
                                <label>First Name</label>
                                <input 
                                    placeholder='Enter First Name' 
                                    name='firstName'
                                    value={input.firstName}
                                    onChange={handleInput}
                                    autoComplete="off"
                                    required
                                />
                            </FormGroup>
                            <FormGroup bottomMargin='0'>
                                <label>Last Name</label>
                                <input 
                                    placeholder='Enter Last Name' 
                                    name='lastName'
                                    value={input.lastName}
                                    onChange={handleInput}
                                    autoComplete="off"
                                    required
                                />
                            </FormGroup>
                        </FlexRow>
                        <FlexRow 
                            justifyContent='space-between' gap='2'
                            className='user-basic-input-row'
                        >
                            <FormGroup bottomMargin='0'>
                                <label>email</label>
                                <input 
                                    placeholder='Enter email' 
                                    name='email'
                                    type='email'
                                    value={input.email}
                                    onChange={handleInput}
                                    autoComplete="off"
                                    required
                                />
                            </FormGroup>
                            <FormGroup bottomMargin='0'>
                                <label>Phone Number</label>
                                <input 
                                    placeholder='Enter Phone Number' 
                                    name='mobileNo'
                                    value={input.mobileNo}
                                    onChange={handleInput}
                                    autoComplete="off"
                                    required
                                />
                            </FormGroup>
                        </FlexRow>
                        <FlexRow 
                            justifyContent='space-between' gap='2'
                            className='user-basic-input-row'
                        >
                            <FormGroup bottomMargin='0'>
                                <label>Channel</label>
                                <input 
                                    placeholder='Enter Channel' 
                                    name='channel'
                                    value={input.channel}
                                    onChange={handleInput}
                                    autoComplete="off"
                                    required
                                />
                            </FormGroup>
                            <FormGroupWithIcon bottomMargin="0">
                                <label>Platform</label>
                                <div 
                                    style={{height: '5.5rem'}}
                                    className="input-with-icon"
                                >
                                    <select 
                                        name='platform'
                                        value={input.platform}
                                        onChange={handleInput}
                                        style={{height: '5.5rem'}}
                                        autoComplete='off'
                                    >
                                        <option value="">--Select--</option>
                                        <option value='Android'>Android</option>
                                        <option value='IOS'>IOS</option>  
                                        <option value='Desktop'>Desktop</option>      
                                    </select>
                                    <FiChevronDown className="input-with-icon-tag" />
                                </div>
                            </FormGroupWithIcon>
                        </FlexRow>
            
                        <FlexRow 
                            justifyContent='flex-end'
                            gap="1" topMargin='5'
                        >
                            <Button 
                                width='15.4' 
                                hoverBgColor='#ffffff'
                                bgColor="#ffffff" 
                                hoverBorderColor='#5627FF'
                                hoverColor='#5627FF'
                                color="#5627FF"
                                onClick={close}
                            >
                                Back
                            </Button>
                            <Button 
                                width='15.4' 
                                hoverBgColor='#ffffff' 
                                hoverColor='#5627FF'
                                borderColor='#5627FF'
                            >
                                Next
                            </Button>
                        </FlexRow>
                    </Form>
                </NewCustomerLayout>
            </FixedContainer>
        </>
    )
}